import Vue from 'vue'
import VueRouter from 'vue-router'
import NotFound from '../views/NotFound.vue'
import MasterDetail from '../views/MasterDetail.vue'
import MasterDetailEmpty from '../views/MasterDetailEmpty.vue'
import MasterDetailSelected from '../views/MasterDetailSelected.vue'
import Newspaper from '../views/Newspaper.vue'
import Grid from '../views/Grid.vue'
import Weekly from '../views/Weekly.vue'
import FavSetEdit from '../views/FavSetEdit.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: { name: 'masterdetailempty' }
  },
  {
    path: '/masterdetail',
    component: MasterDetail,
    children: [
      {
        path: '',
        name: 'masterdetailempty',
        component: MasterDetailEmpty,
        meta: { title: () => 'MasterDetail' }
      },
      {
        path: ':chcode',
        name: 'masterdetailselected',
        component: MasterDetailSelected,
        props: route => ({
          channelCode: route.params.chcode,
          showDate: route.query.showdate
        }),
        meta: { title: route => 'MasterDetail ' + route.params.chcode }
      }
    ]
  },
  {
    path: '/newspaper',
    name: 'newspaper',
    component: Newspaper,
    meta: { title: () => 'Newspaper' }
  },
  {
    path: '/grid',
    name: 'grid',
    component: Grid,
    meta: { title: () => 'Grid' }
  },
  {
    path: '/weekly',
    name: 'weekly',
    component: Weekly,
    meta: { title: () => 'Weekly' }
  },
  {
    path: '/favset/:favsetid/edit',
    name: 'favsetedit',
    component: FavSetEdit,
    props: route => ({
      favSetID: Number(route.params.favsetid)
    }),
    meta: { title: () => 'Edit Favorite Set' }
  },
  {
    path: '*',
    component: NotFound,
    props: route => ({ pathMatch: route.params.pathMatch }),
    meta: { title: () => '404 Not Found' }
  }
]

const router = new VueRouter({
  routes
})

router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title(to);
  })
})

export default router
